<template lang="pug">
  b-container(fluid)
    h2
      .d-flex.align-items-center
        span {{name}}
        h6.d-inline-block.mb-1.ml-3
          b-spinner(small, variant="primary", v-if="loading")
    widget-config(:model_id="model_id", @update="$emit('updatename', $event)")
    hr
    p.mb-0 Generar etiqueta para sitio web
    p.text-secondary El SDK de Widget Web es una etiqueta HTML que se agrega en la cabecera (HEAD) de tu sitio web.
    p.mb-2.text-sm.text-help Copia y pega el siguiente código en el HEAD de tu sitio:
    b-alert(show, variant="secondary")
      span.text-break {{ sdkGenerated }}
    b-link.text-sm(v-b-toggle="'sdk_' + bmid") Configuración avanzada de SDK
    b-collapse.mt-3(:id="'sdk_' + bmid")
      b-card.mb-0.bg-light
        b-alert.text-sm(variant="warning", show) Se require de conocimientos sobre HTML, CSS y formato JSON para esta sección. Si sólo necesitas que se muestre el botón flotante, probablemente no necesites esta configuración.
        b-form-group
          b-form-checkbox(v-model="sdk.button") Mostrar como botón flotante
        b-form.mb-3.px-3(v-if="!sdk.button")
          b-form-group
            b-form-checkbox(v-model="sdk.contained.center") Centrar
          b-form-group
            b-form-checkbox(v-model="sdk.contained.squared") Esquinas cuadradas
          b-form-group(label="Nombre del contenedor", description="Ingresa el selector CSS del contenedor. Puede ser su ID, clase o nombre de elemento: #container, .mi-clase, body.")
            b-form-input(placeholder="Nombre contenedor", v-model="sdk.contained.container")
        b-form-group(label="Parámetros JSON (bm-params)", description="Estos parámetros los recibirá el bot para ser usados en tus flujos. Sólo se genera si es un formato JSON válido. Se omite si se define bm-query-params.", :disabled="Boolean(sdk.bmQueryParams)")
          b-form-input(v-model="sdk.bmParams", debounce="1000", placeholder="Parámetros", :state="bmParamsJSON == undefined ? null : Boolean(bmParamsJSON)")
        b-form-group(label="Parámetros JSON desde URL (bm-query-params)", description="Ingresa el nombre del parámetro disponible en la URL. Debe tener un valor codificado con encodeURIComponent y debe ser un objeto en formato JSON válido.")
          b-input-group
            b-form-input(v-model="sdk.bmQueryParams", placeholder="Nombre parámetro URL")
            b-input-group-append
              b-button(variant="soft-secondary", v-b-tooltip.hover, title="Si los parámetros JSON vienen en el parámetro '&params=xxx', ingresa aquí el nombre: params")
                alert-circle-icon.icon-sm
        p.mb-0.text-help Para cambiar el tamaño del chatbot dentro de un contenedor, modifica la clase
          b.ml-1 .botlers-messaging-chat-iframe.standalone
    hr
    //p.mb-0 Tarjetas de Widget Web
    //p.text-secondary Son tarjetas que muestran información en la página de inicio del Widget Web. Pueden contener imagen de cabecera, título y descripción.
    //b-button.mb-3(variant="soft-secondary", block, @click="cards_modal = true") Administrar tarjetas
    //hr
    p.mb-0 Botón inicio
    p.text-secondary Este botón invita al usuario a iniciar una conversación y te lleva al bloque definido a continuación:
    block-connector(:flow_id="get_started.flow_id", :next_block_id="get_started.next_block", important-only, @change="updateGetStarted")
    .text-center
      b-link.text-sm.text-danger(@click="updateGetStarted(null)") Quitar botón
    hr
    .menu
      p.mb-0 Menú persistente
      p.text-secondary Este menú fijo esta presente en la conversación y al inicio del Widget Web. Pueden conectar con bloques o abrir páginas web.
      .menu-container
        b-input-group.mb-2(v-for="(menu, index) in persistent_menu", :key="menu.bmessaging_menu_id")
          b-form-input(placeholder="Título de botón", v-model="menu.title", trim, @input="updateMenu(menu)")
          b-input-group-append
            block-connector(:flow_id="menu.flow_id", :next_block_id="menu.next_block", :type="menu.type", :url="menu.url", buttonOnly, important-only, @change="updateConnector(menu, $event)")
          b-input-group-append
            b-button(variant="soft-danger", @click="deleteMenu(menu.bmessaging_menu_id)")
              trash-2-icon.icon-sm
        b-row.mb-3
          b-col.my-1(lg="4", offset-lg="2")
            b-button(variant="light", block, @click="createMenu('postback')" :disabled="loading") + Agregar conector
          b-col.my-1(lg="4")
            b-button(variant="light", block, @click="createMenu('web_url')" :disabled="loading") + Agregar botón web
    hr
    p.mb-0 Dominios permitidos
    p.text-secondary Las páginas web permitidas para mostrar el Widget Web.
    .pr-2.mb-2
      b-input-group.mb-2(v-for="(domain, index) in whitelisted_domains", :key="domain.bmessaging_domain_id")
        b-form-input.pointer.bg-white(placeholder="https://", v-model="domain.domain", readonly, @click="toggleDomainModal(domain)")
        b-input-group-append
          b-button(variant="soft-danger", @click="deleteDomain(domain.bmessaging_domain_id)")
            trash-2-icon.icon-sm
    .text-center.my-1
      b-button(variant="light", @click="domain_modal = true") + Agregar dominio
    b-modal(:title="domain_data.bmessaging_domain_id ? 'Actualizar dominio' : 'Crear dominio'", v-model="domain_modal", cancel-title="Cancelar", :ok-title="domain_data.bmessaging_domain_id ? 'Actualizar' : 'Crear'", ok-variant="success", @ok="domain_data.bmessaging_domain_id ? updateDomain($event) : createDomain($event)", :ok-disabled="!domain_data.domain.length || loading", @hidden="resetModal")
      b-container(fluid)
        b-form-group.mb-1
          template(slot="label")
            span.text-secondary.text-sm Dominio:
          b-form-input(placeholder="Dominio", v-model="domain_data.domain")
        b-form-group.mb-1
          template(slot="label")
            span.text-secondary.text-sm Nombre:
          b-form-input(placeholder="Dominio", v-model="domain_data.name")
        b-form-group.mb-1
          template(slot="label")
            span.text-secondary.text-sm Estado:
          b-form-checkbox.ml-1(switch, v-model="domain_data.enabled") {{domain_data.enabled ? 'Activado' : 'Desactivado'}}
    b-modal(centered, size="lg", title="Tarjetas Widget Web", v-model="cards_modal", okOnly, ok-title="Cerrar", ok-variant="secondary")
      bmessaging-cards(:bmessaging_id="bmessaging_id")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import WidgetConfig from '@/components/WidgetConfig'
import BmessagingCards from '@/components/BmessagingCards'
import _debounce from 'lodash.debounce'
const accountController = createNamespacedHelpers('account')
const domainController = createNamespacedHelpers('bmessaging_domain')
const menuController = createNamespacedHelpers('bmessaging_menu')

export default {
  data () {
    return {
      loading: false,
      bmid: null,
      bmessaging_id: null,
      domain_modal: false,
      domain_data: {
        name: '',
        domain: '',
        enabled: true,
        bmessaging_domain_id: null
      },
      secure_domain: false,
      get_started: {
        type: 'postback',
        next_block: null,
        flow_id: null,
        bmessaging_menu_id: null
      },
      cards_modal: false,
      sdk: {
        sendFiles: true,
        sendImages: true,
        src: process.env.VUE_APP_BMID_SDK,
        id: 'botlers-messaging-sdk-v2',
        button: true,
        contained: {
          squared: false,
          center: true,
          container: ''
        },
        bmParams: '',
        bmQueryParams: ''
      }
    }
  },
  props: {
    name: {
        default: ''
    },
    model_id: {
      default: null
    }
  },
  computed: {
    ...accountController.mapGetters(['selectedLanguage']),
    ...domainController.mapState({
      whitelisted_domains: state => state.bmessaging_domains,
    }),
    ...menuController.mapState({
      menu: state => state.bmessaging_menu,
    }),
    persistent_menu () {
      return this.menu.filter(m => {
        return m.type == 'web_url' || m.type == 'postback'
      }).map(m => {
        m[m.type == 'web_url' ? 'url' : 'next_block'] = m.payload
        if(m.type == 'postback') this.getFlowID(m)
        return m
      })
    },
    sdkGenerated () {
      let sdk = this.sdk

      let ui = {attachFiles: sdk.sendFiles, attachImages: sdk.sendImages}
      let encodedUi = encodeURIComponent(JSON.stringify(ui))
      let encodedBmParams = this.bmParamsJSON ? encodeURIComponent(JSON.stringify({ ui: ui, ...this.bmParamsJSON })) : ''

      let scriptInit = `<script id="botlers-messaging-sdk-v2" bmid="${this.bmid}" src="${sdk.src}"`

      if (sdk.bmQueryParams) {
        scriptInit += ` bm-query-params="${sdk.bmQueryParams}"`
      } else if (encodedBmParams) {
        scriptInit += ` bm-params="${encodedBmParams}"`
      } else if (!ui.attachFiles || !ui.attachImages) {
        scriptInit += ` bm-params="${encodedUi}"`
      }

      if (!sdk.button) {
        for (let key in sdk.contained) {
          scriptInit += ` ${key}="${sdk.contained[key]}"`
        }
      }

      let scriptEnd = ` defer="true" async="true"><\/script>`

      return scriptInit + scriptEnd
    },
    bmParamsJSON () {
      let sdk = this.sdk

      if (!sdk.bmParams) return null

      if ( Boolean( this.isJSON(sdk.bmParams) ) ) {
        return this.isJSON(sdk.bmParams)
      } else {
        return ''
      }
    }
  },
  methods: {
    isJSON (string) {
      try {
        return JSON.parse(string)
      } catch (e) {
        return false
      }
    },
    ...mapActions(['block/get', 'bmessaging/get_bmid', 'bmessaging/validate_domain',
                   'bmessaging_domain/all', 'bmessaging_domain/create', 'bmessaging_domain/update', 'bmessaging_domain/destroy',
                   'bmessaging_menu/all', 'bmessaging_menu/create', 'bmessaging_menu/update', 'bmessaging_menu/destroy',]),
    getBmessaging () {
      let self = this
      this.loading = true

      this['bmessaging/get_bmid']({
        account_id: self.$route.params.account_id,
        model_id: self.model_id,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            let account = res.resource.find(a => a.bmessaging_id == self.model_id)
            if(account) {
              self.bmessaging_id = account.bmessaging_id
              self.bmid = account.bmid
              self.getDomains();
              self.getMenu();
            }
          }
        }
      })
    },
    getDomains () {
      let self = this
      this.loading = true

      this['bmessaging_domain/all']({
        bmessaging_id: self.bmessaging_id,
        model_id: self.model_id,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            //console.log(res)
          }
        }
      })
    },
    toggleDomainModal (domain) {
      this.domain_modal = true
      this.domain_data = Object.assign(this.domain_data, domain)
    },
    async createDomain (bvModalEvt) {
      bvModalEvt.preventDefault()
      try {
        let valid_domain = await this.validDomain(this.domain_data.domain)
        if(!valid_domain) return
      } catch (e) {
        console.log(e)
        this.$message.warning('Dominio invalido, por favor verifica que tenga el formato https://dominio.com')
        return
      }

      let self = this
      this.domain_modal = false
      this.loading = true

      this['bmessaging_domain/create']({
        bmessaging_id: self.bmessaging_id,
        ...self.domain_data,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    async updateDomain (bvModalEvt) {
      bvModalEvt.preventDefault()
      try {
        let valid_domain = await this.validDomain(this.domain_data.domain)
        if(!valid_domain) return
      } catch (e) {
        console.log(e)
        this.$message.warning('Dominio invalido, por favor verifica que tenga el formato https://dominio.com')
        return
      }

      let self = this
      this.domain_modal = false
      this.loading = true

      this['bmessaging_domain/update']({
        bmessaging_id: self.bmessaging_id,
        ...self.domain_data,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    validDomain (domain) {
      let self = this
      return new Promise ( (resolve, reject) => {
        let params = { domain: domain }
        this['bmessaging/validate_domain']({
          params,
          callback: res => {
            if (res.error) {
              this.$message.error(res.error)
            }
            resolve(res.success)
          }
        })
      })
    },
    resetModal () {
      this.clearObject(this.domain_data)
      this.domain_data.bmessaging_domain_id = null
      this.domain_data.enabled = true
    },
    deleteDomain (bmessaging_domain_id) {
      let self = this
      this.loading = true

      this['bmessaging_domain/destroy']({
        bmessaging_domain_id: bmessaging_domain_id,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    getMenu () {
      let self = this
      this.loading = true

      this['bmessaging_menu/all']({
        bmessaging_id: self.bmessaging_id,
        model_id: self.model_id,
        callback: async res => {
          this.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            let start_button = res.resource.find(m => m.type == 'get_started')
            if (start_button) {
              self.get_started.next_block = start_button.payload
              self.get_started.bmessaging_menu_id = start_button.bmessaging_menu_id
              self.getFlowID(self.get_started)
            } else {
              self.createGetStarted()
            }
          }
        }
      })
    },
    createGetStarted () {
      let self = this
      this.loading = true

      let start_button = {
        title: "",
        type: 'get_started',
        payload: null,
        bmessaging_id: this.bmessaging_id
      };

      this['bmessaging_menu/create']({
        ...start_button,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            this.get_started.bmessaging_menu_id = res.resource.bmessaging_menu_id
          }
        }
      })
    },
    getFlowID (element) {
      if(!element.next_block) return

      let self = this
      self['block/get']({
        block_id: element.next_block,
        params: {
          platform: 'bmessaging',
          language_id: self.selectedLanguage
        },
        callback: res => {
          if (res.error) {
            this.$message.error(res.error)
          } else {
            element.flow_id =  res.resource.flow_id
          }
        }
      })
    },
    updateGetStarted (data) {
      this.get_started.next_block = data ? data.next_block_id : null
      this.get_started.flow_id = data ? data.flow_id : null
      this.updateMenu(this.get_started, 'get_started')
    },
    updateConnector(element, data) {
      if(element.type === 'web_url') {
        element.url = data.url
      } else {
        element.flow_id = data.flow_id
        element.next_block = data.next_block_id
      }
      this.updateMenu(element)
    },
    createMenu (type) {
      let self = this
      this.loading = true

      let json = {
        title: "",
        type: type,
        payload: null,
        bmessaging_id: this.bmessaging_id
      };

      this['bmessaging_menu/create']({
        ...json,
        callback: res => {
          this.loading = false
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    deleteMenu (bmessaging_menu_id) {
      let self = this
      this.loading = true

      this['bmessaging_menu/destroy']({
        bmessaging_menu_id: bmessaging_menu_id,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
  },
  mounted () {
    this.getBmessaging()

    this.updateMenu = _debounce((menu, get_started) => {
      let self = this
      this.loading = true

      menu.payload = menu.type == 'web_url' ? menu.url : menu.next_block
      menu.type = get_started ? get_started : menu.type

      this['bmessaging_menu/update']({
        ...menu,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.get_started.type = 'postback'
          }
        }
      })
    }, 500, { leading: false,  trailing: true })
  },
  components: {
    WidgetConfig,
    BmessagingCards
  }
}
</script>

<style lang="scss" scoped>
  .menu-item {
    position: relative;
    box-sizing: border-box;
    &:hover {
      .menu-delete {
        display: inline-block;
      }
    }
  }

  .menu-actions {
    position: absolute;
    right: 5px;
  }

  .menu-delete {
    display: none;
  }

  .whitelist-container {
    max-height: 400px;
  }

  .fake-disabled {
    opacity: 1 !important;
    background-color: white !important;
  }
</style>
